import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { environmentService } from './environment';

const initializeFirebase = () => {
  const config = environmentService.getConfig();
  const app = initializeApp(config.firebase);
  const db = getFirestore(app);
  const auth = getAuth(app);
  return { app, db, auth };
};

const { app, db, auth } = initializeFirebase();

export { app, db, auth };
export default app;
